import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';

const { ArrowRight, ArrowUpRight, Ship } = Icons;

const InvestmentSection = () => {
  const { settings, investment } = useSiteData();
  const intro = settings?.investment_intro || {};
  const items = (investment || []).slice().sort((a, b) => a.order - b.order);
  return (
    <section className="relative overflow-hidden bg-[#0B2545] py-24 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 20%, #C9A86A 0%, transparent 35%), radial-gradient(circle at 80% 80%, #C9A86A 0%, transparent 35%)'
        }}
      />
      <div className="relative mx-auto max-w-[1280px] px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {intro.eyebrow}
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-white md:text-[40px]">
              {intro.headline}
            </h2>
            <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
            <p className="mt-7 max-w-md text-[15px] leading-relaxed text-white/75">
              {intro.description}
            </p>
            <Link to="/investment/opportunities" className="group mt-8 inline-flex items-center gap-2 rounded-md bg-[#C9A86A] px-5 py-3 text-[14px] font-medium text-white transition hover:bg-[#b8975c]">
              Explore Opportunities
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {items.map((s) => {
                const Icon = Icons[s.icon] || Ship;
                return (
                  <Link
                    key={s.id || s.slug}
                    to={`/investment/${s.slug}`}
                    className="group flex items-center justify-between gap-4 rounded-lg border border-white/10 bg-white/[0.04] p-5 backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#C9A86A]/60 hover:bg-white/[0.07]"
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-[#C9A86A]/15 text-[#C9A86A]">
                        <Icon size={20} />
                      </div>
                      <div className="text-[15px] font-semibold leading-snug text-white">
                        {s.name}
                      </div>
                    </div>
                    <ArrowUpRight size={16} className="text-[#C9A86A] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentSection;
